import React from 'react';
import { connect } from 'react-redux';

import { AuthCheck } from '@zg-rentals/particles-js-auth';

import { customDimensionsUtils } from '@zg-rentals/analytics-js';
import userUtils from 'app/shared/utils/userUtils';

// actions
import AppActions from 'app/shared/actions/AppActions';
import UserActions from 'app/shared/actions/UserActions';

// selectors
import { getUser } from 'app/shared/selectors/UserSelectors';
import { getRouting } from 'app/shared/selectors/RoutingSelectors';
import AppSelectors from 'app/shared/selectors/AppSelectors';

class AuthCheckWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isReadyToClientSideRedirect: false,
        };
    }

    componentDidMount() {
        const { dispatch, requireStrongAuthentication } = this.props;
        const pageWithSensitiveInformation = requireStrongAuthentication;

        const params = {
            pageWithSensitiveInformation,
            includeSummary: true,
        };

        dispatch(UserActions.getUser(params))
            .then((user) => {
                const {
                    isMultifamilyCustomer,
                    summary,
                    userToken,
                    roles,
                } = user;
                const isRocketshipCustomer = userUtils.isRocketshipCustomer(roles);
                const isNucleusCustomer = userUtils.isNucleusCustomer(roles);
                if (window._kiq && (isMultifamilyCustomer || isRocketshipCustomer || isNucleusCustomer)) {
                    const { activeListingCount, totalListingCount } = summary;
                    const userSummary = customDimensionsUtils.getRentalManagerUserSummary(isMultifamilyCustomer,
                        activeListingCount, totalListingCount, userToken, isRocketshipCustomer, isNucleusCustomer);
                    window._kiq.push(['set', {
                        rentals: 'yes',
                        mfh: isMultifamilyCustomer ? 'yes' : 'no',
                        sfr: isRocketshipCustomer ? 'yes' : 'no',
                        sfn: isNucleusCustomer ? 'yes' : 'no',
                        zuid: userToken,
                        usertype: userSummary,
                    }]);
                }
                this.setState({ isReadyToClientSideRedirect: true });
            });
    }

    handleAuthCheckServerSideRedirect = (redirectUrl) => {
        const { dispatch } = this.props;
        // set redirectUrl in redux, and execute redirect in server side renderer
        return dispatch(AppActions.setServerSideRedirect(redirectUrl));
    }

    render() {
        const {
            brand,
            children,
            loggedIn,
            isTwoFactorAuthEnabled,
            isTwoFactorAuthenticated,
            hasStrongAuthentication,
            router,
            userToken,
            impersonatorUserToken,
            impersonatorEmail,
            requireStrongAuthentication,
        } = this.props;

        const {
            isReadyToClientSideRedirect,
        } = this.state;

        return (
            <AuthCheck
                brand={brand}
                loggedIn={loggedIn}
                hasStrongAuthentication={hasStrongAuthentication}
                impersonatorEmail={impersonatorEmail}
                impersonatorUserToken={impersonatorUserToken}
                isTwoFactorAuthEnabled={isTwoFactorAuthEnabled}
                isTwoFactorAuthenticated={isTwoFactorAuthenticated}
                isReadyToClientSideRedirect={isReadyToClientSideRedirect}
                onRedirectCallback={this.handleAuthCheckServerSideRedirect}
                requireStrongAuthentication={requireStrongAuthentication}
                routing={router}
                userToken={userToken}
            >
                {children}
            </AuthCheck>
        );
    }
}

const mapStateToProps = state => ({
    ...getUser(state),
    brand: AppSelectors.makeBrand(state),
    router: getRouting(state),
});

export default connect(mapStateToProps)(AuthCheckWrapper);
